import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import IconDelete from '../../assets/hkdc/icons/DeleteIcon';
import IconUpload from '../../assets/hkdc/icons/UploadIcon';
import React, { useEffect, useState } from 'react';
import './index.scss';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

export default function UploadComponent(props) {
  const {
    componentStyle,
    componentClass,
    onChangeFile,
    onError,
    uploadTitleText,
    fileTitleText,
    fileNameText = null,
    acceptText,
    descText,
    uploadText,
    limitSize = 1024 * 1024 * 5
  } = props;

  const [filename, setFilename] = useState(null);

  useEffect (() => {
    if (fileNameText) {
      setFilename(fileNameText);
    }
  }, [fileNameText]);

  const onUploadFile = (e) => {
    if (e.target.files) {
      const files = e.target.files;
      const file = files[0];
      const { name, size } = file;

      if (size > limitSize) {
        onError('error.fileSize');
      } else {
        setFilename(name);
        onChangeFile(file);
      }
    }
  };

  return (
    <div className={componentClass} style={componentStyle}>
      <div className="title-text">
        { filename ? fileTitleText : uploadTitleText}
      </div>
      {
        filename ? (
          <div className="file-container">
            <div className="file-text">{filename}</div>
            <IconDelete
              onClick={(e) => {
                e.stopPropagation();
                setFilename(null);
                onChangeFile(null);
              }}
            />
          </div>
        ) : (
          <>
            <Button
              variant="contained"
              component="label"
              role={undefined}
              tabIndex={-1}
              endIcon={<IconUpload />}
            >
              {uploadText}
              <VisuallyHiddenInput
                type="file"
                accept={acceptText}
                onChange={(e) => {
                  e.stopPropagation();
                  onUploadFile(e);
                  e.target.value = '';
                }}

              />
            </Button>
            {descText &&
              <div className="desc-text">
                {descText}
              </div>
            }
          </>
        )
      }

    </div>
  );
}